@file:Suppress("FunctionName")

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.forms.MultiPartFormDataContent
import io.ktor.client.request.forms.formData
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import io.ktor.http.contentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.browser.window
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.accept
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.rows
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.background
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.bottom
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexWrap
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.gridTemplateColumns
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.left
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.listStyleType
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.media
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.right
import org.jetbrains.compose.web.css.top
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.Iframe
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea
import org.jetbrains.compose.web.dom.Ul
import org.jetbrains.compose.web.renderComposable

private val httpClient = HttpClient { install(ContentNegotiation) { json() } }

sealed interface SubmitState {
    data object Idle : SubmitState
    data object Loading : SubmitState
    data class Success(val message: String) : SubmitState
    data class Error(val message: String) : SubmitState
}

enum class LeadTab { Candidate, Recruiter, Payroll }

fun main() {
    renderComposable(rootElementId = "root") {
        val hash = window.location.hash
        if (hash == "#admin") {
            AdminDashboard()
        } else {
            GanrajJobsPage()
        }
    }
}

@Composable
fun GanrajJobsPage() {
    var showModal by remember { mutableStateOf(false) }
    var modalTab by remember { mutableStateOf(LeadTab.Candidate) }

    Style(AppStyles)
    Style(ModalStyles)

    NavigationHeader()
    HeroSection(onAction = { tab ->
        modalTab = tab
        showModal = true
    })
    DetailedAboutSection()
    VisionMissionSection()
    CoreValuesSection()
    WhatMakesUsDifferentSection()
    IndustryPracticesSection()
    ContactSection()
    AppFooter()
    SocialSidebar()
    WhatsAppFAB()

    if (showModal) {
        RegistrationModal(modalTab, onClose = { showModal = false })
    }
}

object AppStyles : StyleSheet() {
    val page by style {
        fontFamily("Roboto, Inter, Arial, sans-serif"); color(Color("#1a365d")); background(
        "#f0f9ff"
    )
    }
    val container by style { maxWidth(1180.px); property("margin", "0 auto"); padding(0.px, 22.px) }
    val card by style {
        backgroundColor(Color.white); borderRadius(28.px); padding(32.px); property(
        "box-shadow",
        "0 4px 20px rgba(0,0,0,0.05)"
    ); border(1.px, LineStyle.Solid, Color("#e0f2fe"))
    }
    val grid by style {
        display(DisplayStyle.Grid); gridTemplateColumns("repeat(auto-fit,minmax(280px,1fr))"); gap(
        20.px
    )
    }
    val cta by style {
        backgroundColor(Color("#0bade3")); color(Color.white); borderRadius(100.px); padding(
        16.px,
        24.px
    ); fontWeight("500"); border(0.px); cursor("pointer"); property("transition", "all 0.2s")

        (self + ":disabled") {
            backgroundColor(Color("#e2e8f0"))
            color(Color("#94a3b8"))
            cursor("not-allowed")
            property("opacity", "0.7")
        }
    }
    val ctaOutlined by style {
        backgroundColor(Color.transparent); color(Color("#0bade3")); borderRadius(100.px); padding(
        16.px,
        24.px
    ); fontWeight("500"); border(
        1.px,
        LineStyle.Solid,
        Color("#0bade3")
    ); cursor("pointer"); property("transition", "all 0.2s")
    }
    val textArea by style {
        width(100.percent); padding(12.px); borderRadius(12.px); marginTop(8.px)
        border(1.px, LineStyle.Solid, Color("#b9d7ea")); property("outline", "none")
        fontFamily("inherit"); fontSize(16.px); backgroundColor(Color.white)
    }
    val socialIcon by style {
        width(48.px); height(48.px); borderRadius(50.percent); display(DisplayStyle.Flex)
        alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
        backgroundColor(rgba(255, 255, 255, 0.1)); color(Color.white)
        fontSize(20.px); cursor("pointer"); property(
        "transition",
        "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)"
    )
        property("text-decoration", "none")
        hover {
            property("transform", "scale(1.2) translateY(-5px)")
            property("box-shadow", "0 15px 30px rgba(0,0,0,0.3)")
        }
    }
    val whyCard by style {
        backgroundColor(Color.white); borderRadius(28.px); padding(32.px)
        border(1.px, LineStyle.Solid, Color("#e0e0e0"))
        property("transition", "all 0.3s ease")
        hover {
            property("transform", "translateY(-10px)")
            property("box-shadow", "0 10px 20px rgba(0,0,0,0.1)")
        }
    }

    val navLink by style {
        cursor("pointer")
        margin(0.px, 12.px)
        fontWeight("500")
        color(Color("#1a365d"))
        property("text-decoration", "none")
        media("(max-width: 600px)") {
            self style {
                margin(0.px, 6.px)
                fontSize(14.px)
                property("white-space", "nowrap")
            }
        }
    }

    val headerTagline by style {
        margin(0.px)
        fontSize(11.px)
        color(Color("#64748b"))
        media("(max-width: 600px)") {
            self style {
                fontSize(9.px)
            }
        }
    }

    val chipSection by style {
        padding(20.px, 0.px, 40.px, 0.px)
        background("linear-gradient(to bottom, #ffffff, #f7f9fc)")
    }

    val chipContainer by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        justifyContent(JustifyContent.Center)
        gap(16.px)
        marginTop(40.px)
    }

    val glowChip by style {
        padding(12.px, 24.px)
        borderRadius(50.px)
        fontSize(16.px)
        fontWeight("600")
        color(Color.white)
        cursor("pointer")
        property("transition", "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)")
        property("user-select", "none")

        property("background-color", "var(--chip-color)")
        property("box-shadow", "0 4px 15px var(--chip-shadow)")

        hover {
            property("transform", "scale(1.1) translateY(-5px)")
            property("box-shadow", "0 10px 25px var(--chip-color)")
        }

        active {
            property("transform", "scale(0.95)")
        }
    }

    val heroTitle by style {
        fontSize(56.px); lineHeight("1.1"); margin(0.px); fontWeight("700")
        media("(max-width: 768px)") { self style { fontSize(36.px) } }
    }
    val logoText by style {
        color(Color("#0bade3")); fontSize(46.px); lineHeight("1.1"); margin(0.px); fontWeight("700")
        media("(max-width: 768px)") { self style { fontSize(32.px) } }
    }
    val sectionTitle by style {
        fontSize(36.px); property("text-align", "center"); color(Color("#1a365d"))
        media("(max-width: 768px)") { self style { fontSize(28.px) } }
    }
    val sectionSubtitle by style {
        property("text-align", "center"); color(Color("#64748b")); fontSize(18.px)
        media("(max-width: 768px)") { self style { fontSize(16.px) } }
    }
    val paymentSection by style {
        backgroundColor(Color("#f8fafc")); padding(16.px); borderRadius(16.px)
        border(1.px, LineStyle.Dashed, Color("#0bade3")); marginTop(24.px); property(
        "text-align",
        "center"
    )
    }
    val socialSidebar by style {
        position(Position.Fixed); right(20.px); top(50.percent); property(
        "transform",
        "translateY(-50%)"
    )
        display(DisplayStyle.Flex); property(
        "flex-direction",
        "column"
    ); gap(12.px); property("z-index", "100")
        media("(max-width: 768px)") { self style { display(DisplayStyle.None) } }
    }
    val sidebarIcon by style {
        width(44.px); height(44.px); borderRadius(50.percent); display(DisplayStyle.Flex)
        alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
        backgroundColor(Color.white); color(Color.white)
        fontSize(20.px); cursor("pointer"); property("box-shadow", "0 4px 10px rgba(0,0,0,0.1)")
        property("transition", "all 0.3s ease"); property("text-decoration", "none")
        hover {
            property("transform", "translateX(-5px)"); property(
            "box-shadow",
            "0 6px 15px rgba(0,0,0,0.2)"
        )
        }
    }
    val whatsappFab by style {
        position(Position.Fixed); bottom(30.px); right(30.px); width(60.px); height(60.px)
        borderRadius(50.percent); backgroundColor(Color("#25D366")); color(Color.white)
        display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
        fontSize(32.px); property("box-shadow", "0 4px 15px rgba(0,0,0,0.3)"); cursor("pointer")
        property("z-index", "1000"); property("text-decoration", "none"); property(
        "transition",
        "all 0.3s ease"
    )
        hover { property("transform", "scale(1.1) rotate(10deg)") }
        media("(max-width: 768px)") {
            self style {
                bottom(80.px); right(20.px); width(56.px); height(56.px); fontSize(30.px)
            }
        }
    }
}

object ModalStyles : StyleSheet() {
    val overlay by style {
        position(Position.Fixed); top(0.px); property(
        "left",
        "0"
    ); width(100.percent); height(100.percent); backgroundColor(
        rgba(0, 0, 0, 0.4)
    ); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center); property(
        "z-index",
        1000
    ); property("backdrop-filter", "blur(4px)")
    }
    val content by style {
        backgroundColor(Color.white); borderRadius(28.px); width(90.percent); maxWidth(800.px); property(
        "max-height",
        "90vh"
    ); property("overflow-y", "auto"); padding(32.px); position(Position.Relative); property(
        "animation",
        "modalPop 0.3s ease-out forwards"
    )
        media("(max-width: 600px)") {
            self style { padding(20.px) }
        }
    }
    val closeBtn by style {
        position(Position.Absolute); top(24.px); property(
        "right",
        "24.px"
    ); cursor("pointer"); fontSize(24.px); color(
        Color("#64748b")
    )
    }
    val fieldWrapper by style {
        display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px); backgroundColor(
        Color("#f0f9ff")
    ); borderRadius(12.px); padding(8.px, 16.px); border(1.px, LineStyle.Solid, Color("#b9d7ea"))
    }
    val icon by style { color(Color("#0bade3")); property("font-family", "Material Icons") }
    val inputBase by style {
        border(0.px); background("transparent"); width(100.percent); padding(8.px); property(
        "outline",
        "none"
    ); fontSize(
        16.px
    ); color(Color("#1a365d"))
    }
}

@Composable
fun NavigationHeader() = org.jetbrains.compose.web.dom.Header(attrs = {
    classes(AppStyles.page); style {
    position(Position.Sticky); top(0.px); property("z-index", 5); backgroundColor(
    rgba(255, 255, 255, 0.95)
); property("backdrop-filter", "blur(12px)"); property("border-bottom", "1px solid #e0e0e0")
}
}) {
    Div({
        classes(AppStyles.container); style {
        display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(
        AlignItems.Center
    ); flexWrap(FlexWrap.Wrap); gap(12.px); padding(
        12.px,
        22.px
    )
    }
    }) {
        Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px) } }) {
            Img(src = "logo.png", alt = "Logo") {
                style {
                    width(44.px); height(44.px); borderRadius(12.px); property(
                    "object-fit",
                    "cover"
                )
                }
            }
            Div {
                H3({ classes(AppStyles.logoText) }) {
                    Text(
                        "GANRAJ"
                    )
                }; P({
                classes(AppStyles.headerTagline)
            }) { Text("JOB PLACEMENT & PAYROLL OUTSOURCING SERVICES") }
            }
        }
    }
}

@Composable
fun HeroSection(onAction: (LeadTab) -> Unit) =
    Section({ classes(AppStyles.page); style { padding(40.px, 0.px) } }) {
        Div({
            classes(AppStyles.container); style {
            display(DisplayStyle.Grid); gridTemplateColumns("repeat(auto-fit,minmax(280px,1fr))"); gap(
            40.px
        ); alignItems(AlignItems.Center)
        }
        }) {
            Div {
                H1({ classes(AppStyles.heroTitle) }) {
                    Text("Your Trust. Our Commitment.")
                }
                Div({
                    style {
                        display(DisplayStyle.Flex); gap(16.px); marginTop(32.px); flexWrap(
                        FlexWrap.Wrap
                    )
                    }
                }) {
                    Button({
                        classes(AppStyles.cta); onClick { onAction(LeadTab.Candidate) }
                    }) { Text("👤 Register as a Candidate") }
                    Button({
                        classes(AppStyles.cta); style { backgroundColor(Color("#1a365d")) }; onClick {
                        onAction(LeadTab.Recruiter)
                    }
                    }) { Text("🏢 Register as an Employer") }
                    Button({
                        classes(AppStyles.cta); style { backgroundColor(Color("#8b5cf6")) }; onClick {
                        onAction(LeadTab.Payroll)
                    }
                    }) { Text("📋 Payroll & Compliance Services") }
                }
            }
        }
    }

@Composable
fun RegistrationModal(tab: LeadTab, onClose: () -> Unit) {
    Div({ classes(ModalStyles.overlay) }) {
        Div({ classes(ModalStyles.content) }) {
            I({
                classes(
                    "material-icons",
                    ModalStyles.closeBtn
                ); onClick { onClose() }
            }) { Text("close") }
            when (tab) {
                LeadTab.Candidate -> CandidateForm(onClose)
                LeadTab.Recruiter -> RecruiterForm(onClose)
                LeadTab.Payroll -> PayrollInfo(onClose)
            }
        }
    }
}

private val industries = listOf(
    "Pharmaceuticals",
    "Information Technology (IT)",
    "Banking & Financial Services",
    "Healthcare & Hospitals",
    "FMCG",
    "Automotive & Auto Components",
    "Engineering & Technical Services",
    "Insurance",
    "Electrical & Electronics",
    "Logistics & Supply Chain",
    "Retail & E-Commerce",
    "Education & EdTech",
    "Telecom & Communication",
    "Food & Beverage",
    "Sales & Marketing",
    "BPO & KPO Services",
    "Hospitality & Tourism",
    "Media & Advertising",
    "Real Estate",
    "Construction & Infrastructure",
    "Chemicals & Specialty Chemicals",
    "Renewable Energy & Power",
    "Professional & Consulting Services",
    "Other"
)

@Composable
fun PaymentInfo() {
    Div({ classes(AppStyles.paymentSection) }) {
        H4({
            style { margin(0.px); color(Color("#1a365d")) }
        }) { Text("Registration Payment") }
        P({ style { fontSize(14.px); color(Color("#64748b")); margin(8.px, 0.px) } }) {
            Text("Please scan the QR code below or use the UPI ID to pay the registration fee.")
        }
        Img(src = "payment_qr.jpeg", alt = "Payment QR Code") {
            style { width(180.px); height(180.px); margin(8.px, 0.px); borderRadius(8.px) }
        }
        Div({
            style {
                display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(
                JustifyContent.Center
            ); gap(8.px)
                backgroundColor(Color.white); padding(8.px); borderRadius(8.px); border(
                1.px,
                LineStyle.Solid,
                Color("#e2e8f0")
            )
            }
        }) {
            B { Text("UPI ID: ") }
            Span({ style { color(Color("#0bade3")); fontWeight("600") } }) { Text("9399415253@axl") }
        }
    }
}

@Composable
fun CandidateForm(onSuccess: () -> Unit) {
    var form by remember { mutableStateOf(CandidateLead()) }
    var state by remember { mutableStateOf<SubmitState>(SubmitState.Idle) }
    var acceptedTerms by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(state) {
        if (state is SubmitState.Success) {
            window.alert((state as SubmitState.Success).message)
            onSuccess()
        }
    }
    H2({
        classes(AppStyles.sectionTitle)
        style { marginBottom(24.px) }
    }) { Text("Candidate Registration") }
    FormGrid {
        input("person", "First Name", form.firstName, isMandatory = true) {
            form = form.copy(firstName = it)
        }
        input("person", "Middle Name", form.middleName) {
            form = form.copy(middleName = it)
        }
        input("person_outline", "Last Name", form.lastName, isMandatory = true) {
            form = form.copy(lastName = it)
        }
        input(
            "phone",
            "Phone",
            form.phone,
            isMandatory = true,
            info = "10-digit mobile number"
        ) { form = form.copy(phone = it) }
        input(
            "contact_phone",
            "Alternate no.",
            form.alternateNo,
            info = "Optional secondary contact"
        ) {
            form = form.copy(alternateNo = it)
        }
        input("email", "Email", form.email, isMandatory = true) { form = form.copy(email = it) }
        input("home", "Temporary Address", form.temporaryAddress, isMandatory = true) {
            form = form.copy(temporaryAddress = it)
        }
        input("location_on", "Permanent Address", form.permanentAddress, isMandatory = true) {
            form = form.copy(permanentAddress = it)
        }
        input(
            "work",
            "Relevant Industry Experience",
            form.fieldExperience,
            isMandatory = true,
            info = "E.g. Java, Sales, Accounting"
        ) {
            form = form.copy(fieldExperience = it)
        }
        input("history", "Additional Experience (If Any)", form.otherExperience, isMandatory = true) {
            form = form.copy(otherExperience = it)
        }
        input(
            "summarize",
            "Total Experience",
            form.totalExperience,
            isMandatory = true,
            info = "Total years of work experience"
        ) {
            form = form.copy(totalExperience = it)
        }
        input(
            "payments",
            "Current CTC (Annual)",
            form.currentCtc,
            isMandatory = true,
            info = "Your current annual package"
        ) { form = form.copy(currentCtc = it) }
        input(
            "trending_up",
            "Expected CTC (Annual)",
            form.expectedCtc,
            isMandatory = true,
            info = "Your expected annual package"
        ) {
            form = form.copy(expectedCtc = it)
        }
        dropdown(
            "business",
            "Current industry",
            form.currentIndustry,
            industries,
            isMandatory = true
        ) {
            form = form.copy(currentIndustry = it)
        }
        if (form.currentIndustry == "Other") {
            input(
                "business",
                "Specify Current Industry",
                form.otherCurrentIndustry,
                isMandatory = true
            ) {
                form = form.copy(otherCurrentIndustry = it)
            }
        }
        dropdown(
            "location_city",
            "Expected industry",
            form.expectedIndustry,
            industries,
            isMandatory = true
        ) {
            form = form.copy(expectedIndustry = it)
        }
        if (form.expectedIndustry == "Other") {
            input(
                "location_city",
                "Specify Expected Industry",
                form.otherExpectedIndustry,
                isMandatory = true
            ) {
                form = form.copy(otherExpectedIndustry = it)
            }
        }
        dropdown(
            "event",
            "Notice Period",
            form.noticePeriod,
            listOf("Immediate", "15 Days", "30 Days", "45 Days", "60 Days", "90 Days", "Other"),
            isMandatory = true
        ) {
            form = form.copy(noticePeriod = it)
        }
        dropdown(
            "work",
            "Preferred Job Type",
            form.preferredJobType,
            listOf("Full-Time", "Part-Time", "Contract", "Temporary", "Internship", "Hourly Basis", "Other"),
            isMandatory = true
        ) {
            form = form.copy(preferredJobType = it)
        }
        Div({ style { property("grid-column", "1 / -1") } }) {
            SkillsChipInput(
                "Key Skills",
                form.keySkills,
                isMandatory = true,
                info = "Type a skill and press Enter to add it as a chip"
            ) { form = form.copy(keySkills = it) }
        }
        input("place", "Current Location", form.currentLocation, isMandatory = true) {
            form = form.copy(currentLocation = it)
        }
        input(
            "map",
            "Preferred Job Location",
            form.expectedLocations,
            isMandatory = true,
            info = "Cities you are willing to work in"
        ) {
            form = form.copy(expectedLocations = it)
        }
        dropdown(
            "campaign",
            "How did you hear about us?",
            form.referenceLead,
            listOf("Google", "Facebook", "Instagram", "LinkedIn", "WhatsApp", "Friend / Reference", "Other"),
            isMandatory = true
        ) {
            form = form.copy(referenceLead = it)
        }
        Div {
            Label {
                Input(InputType.Checkbox) {
                    checked(form.emailAlerts); onInput {
                    form = form.copy(emailAlerts = it.target.checked)
                }
                }
                Text(" Email Alerts (Optional)")
            }
        }
        Div {
            Label {
                Text("Resume Upload (PDF Preferred) ")
                Span({
                    style { color(Color.red) }
                }) { Text("*") }
                Input(InputType.File) {
                    accept(".pdf,.docx,.doc"); onInput {
                    val file = it.target.files?.item(0)
                    form = form.copy(resumeName = file?.name.orEmpty())
                }
                }
                Small { Text(form.resumeName) }
            }
        }
        Div({ style { property("grid-column", "1 / -1"); marginTop(16.px) } }) {
            Label {
                Div({
                    style {
                        display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px); marginBottom(
                        8.px
                    )
                    }
                }) {
                    Text("Payment Commitment")
                    Span({ style { color(Color.red) } }) { Text("*") }
                }
                Div({ style { display(DisplayStyle.Flex); flexWrap(FlexWrap.Wrap); gap(16.px) } }) {
                    Label {
                        Input(InputType.Radio) {
                            name("paymentCommitment")
                            checked(form.paymentCommitment == "PDC")
                            onInput { form = form.copy(paymentCommitment = "PDC") }
                        }
                        Text(" Option A: Post-Dated Cheque (PDC)")
                    }
                    Label {
                        Input(InputType.Radio) {
                            name("paymentCommitment")
                            checked(form.paymentCommitment == "Undertaking")
                            onInput { form = form.copy(paymentCommitment = "Undertaking") }
                        }
                        Text(" Option B: Payment Undertaking")
                    }
                }
            }
        }
        Div({ style { property("grid-column", "1 / -1"); marginTop(16.px) } }) {
            Label {
                Input(InputType.Checkbox) {
                    checked(acceptedTerms)
                    onInput { acceptedTerms = it.target.checked }
                }
                Text(" I have read, understood and agree to the ")
                A(href = "/candidate_terms.html", attrs = {
                    attr("target", "_blank")
                    style {
                        color(Color("#6750a4")); fontWeight("600"); property(
                        "text-decoration",
                        "underline"
                    )
                    }
                }) { Text("Terms & Conditions") }
                Text(" of Ganraj Job Placement & Payroll Outsourcing Services.")
            }
        }
    }
    PaymentInfo()
    SubmitStatus(state)
    Button({
        classes(AppStyles.cta); style { marginTop(24.px); width(100.percent) }
        if (state is SubmitState.Loading) disabled()
        onClick {
            val error = validateCandidate(form)
            if (!acceptedTerms) state = SubmitState.Error("Please accept the Terms & Conditions.")
            else if (error != null) state = SubmitState.Error(error)
            else scope.launch {
                state = SubmitState.Loading
                val fileInput =
                    window.document.querySelector("input[type='file']") as? org.w3c.dom.HTMLInputElement
                val file = fileInput?.files?.item(0)
                state = submitCandidate(form, file)
            }
        }
    }) { Text("Submit CV") }
}

@Composable
fun PayrollInfo(onClose: () -> Unit) {
    H2({
        classes(AppStyles.sectionTitle)
        style { marginBottom(24.px) }
    }) { Text("Payroll & Compliance Services") }
    Div({ style { padding(16.px); color(Color("#1e293b")) } }) {
        Div({
            style {
                display(DisplayStyle.Grid)
                gridTemplateColumns("repeat(auto-fit, minmax(280px, 1fr))")
                gap(32.px)
            }
        }) {
            ServiceCategory(
                "A. Payroll Services", listOf(
                    "End-to-End Payroll Processing",
                    "Salary Calculation & Processing",
                    "Payslip Generation",
                    "Attendance, Leave & Overtime Processing",
                    "Bonus, Incentive & Arrears Processing",
                    "Full & Final Settlement (F&F)",
                    "Employee Master Data Management",
                    "Payroll Reports & MIS",
                    "HR Payroll Documentation",
                    "Payroll Support & Consultation"
                )
            )

            ServiceCategory(
                "B. Statutory Compliance Services", listOf(
                    "EPF Compliance Management",
                    "ESIC Compliance Management",
                    "Professional Tax (PT) Compliance",
                    "Labour Welfare Fund (LWF) Compliance",
                    "Monthly PF & ESIC Challan Support",
                    "PF & ESIC Returns Support",
                    "Labour Law Compliance Support",
                    "Statutory Registers & Records Maintenance",
                    "Compliance Documentation",
                    "Audit Support"
                )
            )

            ServiceCategory(
                "C. Registration Services", listOf(
                    "EPF Registration",
                    "ESIC Registration",
                    "Professional Tax (PT) Registration",
                    "Labour Welfare Fund Registration",
                    "Principal Employer Registration",
                    "Contract Labour (CLRA) Registration",
                    "Factory Licence Support",
                    "Labour Licence Support",
                    "Labour Law Registration Assistance",
                    "Registration Documentation Support"
                )
            )
        }

        Div({
            style {
                marginTop(24.px); padding(24.px); backgroundColor(rgba(11, 173, 227, 0.05))
                borderRadius(16.px); border(1.px, LineStyle.Solid, Color("#0bade3"))
            }
        }) {
            H4({ style { margin(0.px); marginBottom(12.px); color(Color("#1a365d")); fontWeight("700") } }) { 
                I({ classes("material-icons"); style { fontSize(20.px); property("vertical-align", "middle"); property("margin-right", "8px") } }) { Text("info") }
                Text("Service customisation and terms:-") 
            }
            P({ style { fontSize(15.px); color(Color("#1e293b")); lineHeight("1.6"); margin(0.px) } }) {
                Text("The services listed above can be customized based on your organization’s requirements, employee strength, and scope of work. Service scope, charges, and applicable terms will be mutually discussed and finalized before commencement of the services.")
            }
        }
    }
    Button({
        classes(AppStyles.cta); style { marginTop(24.px); width(100.percent) }
        onClick { onClose() }
    }) { Text("Close") }
}

@Composable
private fun ServiceCategory(title: String, services: List<String>) = Div {
    H3({
        style {
            color(Color("#0bade3")); fontSize(18.px); marginBottom(16.px)
            property("border-left", "4px solid #0bade3"); paddingLeft(12.px)
        }
    }) { Text(title) }
    Ul({
        style { listStyleType("none"); padding(0.px); margin(0.px) }
    }) {
        services.forEach { service ->
            Li({
                style {
                    display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px)
                    marginBottom(8.px); fontSize(14.px); color(Color("#475569"))
                }
            }) {
                I({
                    classes("material-icons")
                    style { fontSize(16.px); color(Color("#10b981")) }
                }) { Text("check_circle") }
                Text(service)
            }
        }
    }
}

@Composable
fun RecruiterForm(onSuccess: () -> Unit) {
    var f by remember { mutableStateOf(RecruiterLead()) }
    var state by remember { mutableStateOf<SubmitState>(SubmitState.Idle) }
    var acceptedTerms by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(state) {
        if (state is SubmitState.Success) {
            window.alert((state as SubmitState.Success).message)
            onSuccess()
        }
    }
    H2({
        classes(AppStyles.sectionTitle)
        style { marginBottom(24.px) }
    }) { Text("Recruiter Registration") }
    
    H3({ style { color(Color("#0bade3")); marginBottom(16.px); marginTop(24.px) } }) { 
        Text("SECTION 1: EMPLOYER & COMPANY DETAILS") 
    }
    
    FormGrid {
        input("business", "Company Name", f.companyName, isMandatory = true) {
            f = f.copy(companyName = it)
        }
        input("person", "Employer Full Name", f.employerName, isMandatory = true) {
            f = f.copy(employerName = it)
        }
        input("badge", "Designation", f.designation, isMandatory = true) {
            f = f.copy(designation = it)
        }
        dropdown(
            "groups",
            "Department",
            f.employerDepartment,
            listOf("HR", "Finance", "Sales", "Marketing", "IT", "Operations", "Legal", "Other"),
            isMandatory = true
        ) {
            f = f.copy(employerDepartment = it)
        }
        input(
            "people",
            "Total Number of Vacancies",
            f.totalVacancies,
            isMandatory = true
        ) {
            f = f.copy(totalVacancies = it)
        }
        input("email", "Company Email", f.companyEmail, isMandatory = true) {
            f = f.copy(companyEmail = it)
        }
        input(
            "phone",
            "Contact Number",
            f.contactNumber,
            isMandatory = true,
            info = "10-digit mobile number"
        ) { f = f.copy(contactNumber = it) }
        input("home", "Company Address", f.companyAddress, isMandatory = true) {
            f = f.copy(companyAddress = it)
        }
        input(
            "language",
            "Company Website",
            f.companyWebsite,
            info = "e.g. https://www.example.com"
        ) {
            f = f.copy(companyWebsite = it)
        }
        input(
            "receipt",
            "GSTIN No.",
            f.gstnNo,
            info = "Your company's GST Identification Number"
        ) { f = f.copy(gstnNo = it) }
    }

    H3({ style { color(Color("#0bade3")); marginBottom(16.px); marginTop(32.px) } }) { 
        Text("SECTION 2: RECRUITMENT DETAILS") 
    }

    FormGrid {
        input("work", "Position / Designation Required", f.requiredPosition, isMandatory = true) {
            f = f.copy(requiredPosition = it)
        }
        dropdown(
            "groups",
            "Department",
            f.recruitmentDepartment,
            listOf("HR", "Finance", "Sales", "Marketing", "IT", "Operations", "Legal", "Other"),
            isMandatory = true,
            info = "The department for which you are hiring"
        ) {
            f = f.copy(recruitmentDepartment = it)
        }
        if (f.recruitmentDepartment == "Other") {
            input("groups", "Specify Other Department", f.otherRecruitmentDepartment, isMandatory = true) {
                f = f.copy(otherRecruitmentDepartment = it)
            }
        }
        input(
            "people",
            "Number of Vacancies in This Department",
            f.departmentVacancies,
            isMandatory = true
        ) {
            f = f.copy(departmentVacancies = it)
        }
        input("payments", "Offered CTC (LPA)", f.offeredCtc, isMandatory = true) {
            f = f.copy(offeredCtc = it)
        }
        input("history", "Experience Required", f.experienceRequired, isMandatory = true) {
            f = f.copy(experienceRequired = it)
        }
        input("school", "Qualification", f.qualification, isMandatory = true) {
            f = f.copy(qualification = it)
        }
        dropdown(
            "work",
            "Job Type",
            f.jobType,
            listOf("Full Time", "Part Time", "Contract", "Freelance", "Internship", "Other"),
            isMandatory = true
        ) { f = f.copy(jobType = it) }
        if (f.jobType == "Other") {
            input("work", "Specify Other Job Type", f.otherJobType, isMandatory = true) {
                f = f.copy(otherJobType = it)
            }
        }
        dropdown(
            "wc",
            "Gender Preference",
            f.genderPreference,
            listOf("Male", "Female", "Any"),
            isMandatory = true
        ) { f = f.copy(genderPreference = it) }
        input("event", "Joining Timeline", f.joiningTimeline, isMandatory = true) {
            f = f.copy(joiningTimeline = it)
        }
        dropdown(
            "video_call",
            "Interview Mode",
            f.interviewMode,
            listOf("Online / Virtual", "Face to Face", "Telephonic"),
            isMandatory = true
        ) { f = f.copy(interviewMode = it) }
        Div({ style { property("grid-column", "1 / -1") } }) {
            SkillsChipInput(
                "Skills Required",
                f.skillsRequired,
                isMandatory = true,
                info = "The specific skills required for this job"
            ) { f = f.copy(skillsRequired = it) }
        }
        Div({ style { property("grid-column", "1 / -1") } }) {
            Label {
                Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px) } }) {
                    Text("Hiring Requirements Description")
                    Span({
                        style { color(Color.red) }
                    }) { Text("*") }
                }
                TextArea(value = f.hiringDescription, attrs = {
                    onInput { f = f.copy(hiringDescription = it.value) }; rows(4)
                    classes(AppStyles.textArea)
                    attr("placeholder", "Describe your detailed hiring requirements...")
                })
            }
        }
        input(
            "note",
            "Special Note",
            f.specialNote,
            info = "Any specific instructions or preferences"
        ) { f = f.copy(specialNote = it) }
    }
    Div({ style { property("grid-column", "1 / -1"); marginTop(16.px) } }) {
        Label {
            Input(InputType.Checkbox) {
                checked(acceptedTerms)
                onInput { acceptedTerms = it.target.checked }
            }
            Text(" I have read, understood and agree to the ")
            A(href = "/recruiter_terms.html", attrs = {
                attr("target", "_blank")
                style {
                    color(Color("#6750a4")); fontWeight("600"); property(
                    "text-decoration",
                    "underline"
                )
                }
            }) { Text("Terms & Conditions") }
            Text(" of Ganraj Job Placement & Payroll Outsourcing Services.")
        }
    }
    PaymentInfo()
    SubmitStatus(state)
    Button({
        classes(AppStyles.cta); style { marginTop(24.px); width(100.percent) }
        if (state is SubmitState.Loading) disabled()
        onClick {
            val error = validateRecruiter(f)
            if (!acceptedTerms) state = SubmitState.Error("Please accept the Terms & Conditions.")
            else if (error != null) state = SubmitState.Error(error)
            else scope.launch { state = SubmitState.Loading; state = submitRecruiter(f) }
        }
    }) { Text("Submit Lead") }
}

@Composable
private fun FormGrid(content: @Composable () -> Unit) =
    Div({ classes(AppStyles.grid) }) { content() }

@Composable
private fun input(
    icon: String,
    label: String,
    value: String,
    isMandatory: Boolean = false,
    info: String? = null,
    onChange: (String) -> Unit
) = Label {
    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px) } }) {
        Text(label)
        if (isMandatory) {
            Span({
                style { color(Color.red) }
            }) { Text("*") }
        } else {
            Small({ style { color(Color("#64748b")); fontSize(11.px) } }) { Text(" (Optional)") }
        }
        if (info != null) {
            I({
                classes("material-icons")
                style { cursor("pointer"); fontSize(14.px); color(Color("#6750a4")); marginLeft(2.px) }
                attr("title", info)
                onClick { window.alert(info) }
            }) { Text("info") }
        }
    }
    Div({ classes(ModalStyles.fieldWrapper); style { marginTop(6.px) } }) {
        I({ classes("material-icons", ModalStyles.icon) }) { Text(icon) }
        Input(InputType.Text) {
            classes(ModalStyles.inputBase); value(value); onInput { onChange(it.value) }
            attr("placeholder", if (isMandatory) label else "$label (Optional)")
        }
    }
}

@Composable
private fun dropdown(
    icon: String,
    label: String,
    value: String,
    options: List<String>,
    isMandatory: Boolean = false,
    info: String? = null,
    onChange: (String) -> Unit
) = Label {
    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px) } }) {
        Text(label)
        if (isMandatory) {
            Span({
                style { color(Color.red) }
            }) { Text("*") }
        } else {
            Small({ style { color(Color("#64748b")); fontSize(11.px) } }) { Text(" (Optional)") }
        }
        if (info != null) {
            I({
                classes("material-icons")
                style { cursor("pointer"); fontSize(14.px); color(Color("#6750a4")); marginLeft(2.px) }
                attr("title", info)
                onClick { window.alert(info) }
            }) { Text("info") }
        }
    }
    Div({ classes(ModalStyles.fieldWrapper); style { marginTop(6.px) } }) {
        I({ classes("material-icons", ModalStyles.icon) }) { Text(icon) }
        Select(attrs = {
            classes(ModalStyles.inputBase); onInput { onChange(it.value ?: "") }
        }) {
            Option("", attrs = { if (value.isEmpty()) selected() }) { Text("Select $label") }
            options.forEach { opt ->
                Option(opt, attrs = { if (opt == value) selected() }) {
                    Text(
                        opt
                    )
                }
            }
        }
    }
}

@Composable
private fun SubmitStatus(state: SubmitState) {
    when (state) {
        SubmitState.Idle -> Unit
        SubmitState.Loading -> P { Text("Submitting...") }
        is SubmitState.Success -> P({ style { color(Color("#047857")); fontWeight("600") } }) {
            Text(
                state.message
            )
        }

        is SubmitState.Error -> P({ style { color(Color("#b91c1c")); fontWeight("600") } }) {
            Text(
                state.message
            )
        }
    }
}

private val emailRegex = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$")

@Composable
private fun SkillsChipInput(
    label: String,
    skills: String,
    isMandatory: Boolean = false,
    info: String? = null,
    onUpdate: (String) -> Unit
) {
    var textValue by remember { mutableStateOf("") }
    val skillList =
        if (skills.isEmpty()) emptyList() else skills.split(",").filter { it.isNotBlank() }

    Label {
        Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px) } }) {
            Text(label)
            if (isMandatory) {
                Span({ style { color(Color.red) } }) { Text("*") }
            }
            if (info != null) {
                I({
                    classes("material-icons")
                    style {
                        cursor("pointer"); fontSize(14.px); color(Color("#6750a4")); marginLeft(
                        2.px
                    )
                    }
                    attr("title", info)
                    onClick { window.alert(info) }
                }) { Text("info") }
            }
        }
        Div({
            classes(ModalStyles.fieldWrapper)
            style {
                marginTop(6.px); display(DisplayStyle.Flex); flexWrap(FlexWrap.Wrap); gap(8.px); padding(
                8.px
            )
                property("min-height", "48.px"); alignItems(AlignItems.Center)
            }
        }) {
            skillList.forEach { skill ->
                Div({
                    style {
                        display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px)
                        backgroundColor(Color("#e0f2fe")); color(Color("#1a365d")); padding(
                        4.px,
                        12.px
                    )
                        borderRadius(8.px); fontSize(14.px); fontWeight("500")
                    }
                }) {
                    Text(skill.trim())
                    I({
                        classes("material-icons")
                        style { fontSize(16.px); cursor("pointer") }
                        onClick {
                            onUpdate(skillList.filter { it != skill }.joinToString(","))
                        }
                    }) { Text("close") }
                }
            }
            Input(InputType.Text) {
                style {
                    border(0.px); property("outline", "none"); property(
                    "flex",
                    "1"
                ); property("min-width", "120.px"); background("transparent")
                    fontSize(16.px)
                }
                value(textValue)
                attr(
                    "placeholder",
                    if (skillList.isEmpty()) "Type skill and press Enter..." else ""
                )
                onInput { textValue = it.value }
                onKeyDown {
                    if (it.key == "Enter") {
                        it.preventDefault()
                        if (textValue.isNotBlank() && !skillList.contains(textValue.trim())) {
                            onUpdate(if (skills.isEmpty()) textValue.trim() else "$skills,${textValue.trim()}")
                            textValue = ""
                        }
                    }
                }
            }
        }
    }
}

private fun validateCandidate(f: CandidateLead): String? = when {
    f.firstName.isBlank() || f.lastName.isBlank() -> "Name is required."
    !Regex("^[0-9]{10}$").matches(f.phone.trim()) -> "Phone must be 10 digits."
    !emailRegex.matches(f.email.trim()) -> "Valid email required."
    f.temporaryAddress.isBlank() -> "Temporary Address is required."
    f.permanentAddress.isBlank() -> "Permanent Address is required."
    f.fieldExperience.isBlank() -> "Relevant Industry Experience is required."
    f.otherExperience.isBlank() -> "Additional Experience is required."
    f.totalExperience.isBlank() -> "Total Experience is required."
    f.currentCtc.isBlank() -> "Current CTC is required."
    f.expectedCtc.isBlank() -> "Expected CTC is required."
    f.currentIndustry == "Other" && f.otherCurrentIndustry.isBlank() -> "Please specify your current industry."
    f.expectedIndustry == "Other" && f.otherExpectedIndustry.isBlank() -> "Please specify your expected industry."
    f.noticePeriod.isBlank() -> "Notice Period is required."
    f.preferredJobType.isBlank() -> "Preferred Job Type is required."
    f.currentLocation.isBlank() -> "Current Location is required."
    f.expectedLocations.isBlank() -> "Preferred Job Location is required."
    f.referenceLead.isBlank() -> "Source (How did you hear about us?) is required."
    f.resumeName.isBlank() -> "Resume is required."
    f.paymentCommitment.isBlank() -> "Please select a Payment Commitment option."
    else -> null
}

private fun validateRecruiter(f: RecruiterLead): String? = when {
    f.companyName.isBlank() -> "Company Name is required."
    f.employerName.isBlank() -> "Employer Full Name is required."
    f.designation.isBlank() -> "Designation is required."
    f.employerDepartment.isBlank() -> "Department (Section 1) is required."
    f.totalVacancies.isBlank() -> "Total Number of Vacancies is required."
    f.companyAddress.isBlank() -> "Company Address is required."
    f.requiredPosition.isBlank() -> "Position / Designation Required is required."
    f.recruitmentDepartment.isBlank() -> "Department (Section 2) is required."
    f.recruitmentDepartment == "Other" && f.otherRecruitmentDepartment.isBlank() -> "Please specify your recruitment department."
    f.departmentVacancies.isBlank() -> "Number of Vacancies in This Department is required."
    f.skillsRequired.isBlank() -> "Skills Required is required."
    f.hiringDescription.isBlank() -> "Hiring Description is required."
    f.offeredCtc.isBlank() -> "Offered CTC is required."
    f.experienceRequired.isBlank() -> "Experience Required is required."
    f.qualification.isBlank() -> "Qualification is required."
    f.jobType.isBlank() -> "Job Type is required."
    f.jobType == "Other" && f.otherJobType.isBlank() -> "Please specify your job type."
    f.genderPreference.isBlank() -> "Gender Preference is required."
    f.joiningTimeline.isBlank() -> "Joining Timeline is required."
    f.interviewMode.isBlank() -> "Interview Mode is required."
    !emailRegex.matches(f.companyEmail.trim()) -> "Valid company email required."
    !Regex("^[0-9]{10}$").matches(f.contactNumber.trim()) -> "Phone must be 10 digits."
    else -> null
}

private suspend fun submitCandidate(f: CandidateLead, file: org.w3c.files.File?): SubmitState =
    runCatching {
        val fileBytes = file?.asArrayBuffer()
        val response = httpClient.post("/api/employees") {
            if (fileBytes != null && file != null) {
                setBody(MultiPartFormDataContent(formData {
                    append("candidate", Json.encodeToString(f))
                    append("resume", fileBytes, Headers.build {
                        append(HttpHeaders.ContentType, "application/octet-stream")
                        append(HttpHeaders.ContentDisposition, "filename=\"${file.name}\"")
                    })
                }))
            } else {
                contentType(ContentType.Application.Json)
                setBody(f)
            }
        }
        if (response.status.value in 200..299) {
            SubmitState.Success("Submitted successfully.")
        } else {
            SubmitState.Error("Server error: ${response.status}")
        }
    }.getOrElse { SubmitState.Error(it.message ?: "Failed.") }

private suspend fun org.w3c.files.File.asArrayBuffer(): ByteArray {
    val reader = org.w3c.files.FileReader()
    val deferred = kotlinx.coroutines.CompletableDeferred<ByteArray>()
    reader.onload = {
        val result = reader.result as org.khronos.webgl.ArrayBuffer
        deferred.complete(org.khronos.webgl.Int8Array(result).unsafeCast<ByteArray>())
    }
    reader.onerror = { deferred.completeExceptionally(Exception("File read error")) }
    reader.readAsArrayBuffer(this)
    return deferred.await()
}

private suspend fun submitRecruiter(f: RecruiterLead): SubmitState = runCatching {
    val response = httpClient.post("/api/recruiters") {
        contentType(ContentType.Application.Json)
        setBody(f)
    }
    if (response.status.value in 200..299) {
        SubmitState.Success("Submitted successfully.")
    } else {
        SubmitState.Error("Server error: ${response.status}")
    }
}.getOrElse { SubmitState.Error(it.message ?: "Failed.") }

@Composable
fun AboutSection() = Section({ classes(AppStyles.container); style { padding(80.px, 22.px) } }) {
    H2({
        style {
            property(
                "text-align",
                "center"
            ); marginBottom(40.px)
        }
    }) { Text("Why Choose Ganraj Jobs?") }
    Div({ classes(AppStyles.grid) }) {
        AboutCard(
            "verified",
            "Reliable Service",
            "We build long-term relationships based on trust and success."
        )
        AboutCard(
            "payments",
            "Affordable Pricing",
            "Premium recruitment solutions at competitive industry rates."
        )
        AboutCard(
            "psychology",
            "Expert Team",
            "Years of experience in HR, payroll, and talent acquisition."
        )
    }
}

@Composable
fun AboutCard(icon: String, title: String, desc: String) =
    Div({ classes(AppStyles.card); style { property("text-align", "center") } }) {
        I({
            classes("material-icons")
            style { fontSize(48.px); color(Color("#0bade3")); marginBottom(16.px) }
        }) { Text(icon) }
        H3 { Text(title) }
        P({ style { color(Color("#64748b")) } }) { Text(desc) }
    }

@Composable
fun ContactSection() = Section({ classes(AppStyles.container); style { padding(40.px, 22.px) } }) {
    H2({
        classes(AppStyles.sectionTitle)
        style { property("text-align", "left"); marginBottom(24.px) }
    }) { Text("Contact Us") }
    Div({ style { display(DisplayStyle.Flex); gap(40.px); flexWrap(FlexWrap.Wrap); marginBottom(32.px) } }) {
        ContactItem("email", "info@ganrajjobs.com")
        ContactItem("email", "careers@ganrajjobs.com")
        ContactItem("schedule", "Mon-Sat 11am-6pm")
        ContactItem("location_on", "Indore, Madhya Pradesh, India")
    }
    Iframe(attrs = {
        attr("src", "https://www.google.com/maps?q=Indore&output=embed")
        style { width(100.percent); height(400.px); borderRadius(28.px); border(0.px) }
    })
}

@Composable
fun IndustryPracticesSection() = Section({
    classes(AppStyles.chipSection)
}) {
    val industryList = listOf(
        "Pharmaceuticals" to "#0bade3",
        "Information Technology (IT)" to "#0bade3",
        "Banking & Financial Services" to "#10b981",
        "Healthcare & Hospitals" to "#f59e0b",
        "FMCG" to "#3b82f6",
        "Automotive & Auto Components" to "#ec4899",
        "Engineering & Technical Services" to "#8b5cf6",
        "Insurance" to "#06b6d4",
        "Electrical & Electronics" to "#f43f5e",
        "Logistics & Supply Chain" to "#f97316",
        "Retail & E-Commerce" to "#14b8a6",
        "Education & EdTech" to "#0bade3",
        "Telecom & Communication" to "#10b981",
        "Food & Beverage" to "#f59e0b",
        "Sales & Marketing" to "#3b82f6",
        "BPO & KPO Services" to "#ec4899",
        "Hospitality & Tourism" to "#8b5cf6",
        "Media & Advertising" to "#06b6d4",
        "Real Estate" to "#f43f5e",
        "Construction & Infrastructure" to "#f97316",
        "Chemicals & Specialty Chemicals" to "#14b8a6",
        "Renewable Energy & Power" to "#0bade3",
        "Professional & Consulting Services" to "#10b981"
    )

    Div({ classes(AppStyles.container) }) {
        H2({
            classes(AppStyles.sectionTitle)
            style { marginBottom(12.px) }
        }) { Text("INDUSTRIES WE SERVE") }

        P({
            classes(AppStyles.sectionSubtitle)
            style { marginBottom(40.px) }
        }) { Text("Specialized Recruitment & HR Solutions Across Diverse Sectors") }

        Div({ classes(AppStyles.chipContainer) }) {
            industryList.forEach { (name, colorHex) ->
                Div({
                    classes(AppStyles.glowChip)
                    style {
                        property("--chip-color", colorHex)
                        property("--chip-shadow", colorHex + "4d") // ~30% opacity
                    }
                }) {
                    Text(name)
                }
            }
        }
    }
}

@Composable
fun ContactItem(icon: String, info: String) =
    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px) } }) {
        I({ classes("material-icons"); style { color(Color("#0bade3")) } }) { Text(icon) }
        P({ style { margin(0.px); fontWeight("500") } }) { Text(info) }
    }

@Composable
fun BankInfoItem(label: String, value: String) = Div({
    style {
        display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(
        AlignItems.Center
    )
        property("padding-bottom", "12px"); property("border-bottom", "1px solid #f1f5f9")
        flexWrap(FlexWrap.Wrap); gap(8.px)
    }
}) {
    Span({
        style {
            color(Color("#64748b")); fontWeight("500"); fontSize(14.px); property(
            "text-transform",
            "uppercase"
        )
        }
    }) { Text(label) }
    B({ style { color(Color("#1e293b")); fontSize(18.px) } }) { Text(value) }
}

@Composable
fun DetailedAboutSection() = Section({
    classes(AppStyles.container); style { padding(40.px, 22.px) }
}) {
    Div({
        style {
            display(DisplayStyle.Grid); gridTemplateColumns("repeat(auto-fit, minmax(280px, 1fr))"); gap(
            60.px
        )
            alignItems(AlignItems.Center)
        }
    }) {
        Div {
            H2({
                classes(AppStyles.sectionTitle)
                style {
                    color(Color("#0bade3")); property(
                    "text-align",
                    "left"
                ); marginBottom(24.px)
                }
            }) { Text("ABOUT US") }
            P({ style { fontSize(18.px); lineHeight("1.6"); color(Color("#64748b")) } }) {
                Text("Ganraj Job Placement & Payroll Outsourcing Services is a professional HR solutions firm offering Recruitment, Payroll Outsourcing, and HR Support Services for businesses and professionals.\n" +
                        "We connect businesses with the right talent and provide practical HR solutions aligned with their workforce requirements, while helping candidates access relevant career opportunities. Our approach is centered on understanding business needs, creating meaningful professional connections, and delivering solutions that add value to both organizations and professionals.")
            }
            H3({ style { color(Color("#1a365d")); marginTop(16.px) } }) { Text("Your Trust. Our Commitment.") }
        }
        Div({
            classes(AppStyles.card); style {
            background("linear-gradient(135deg, #0bade3 0%, #1a365d 100%)"); color(Color.white)
            property("transform", "rotate(2deg)")
        }
        }) {
            P({ style { fontSize(20.px); fontWeight("500") } }) {
                Text("Ganraj Jobs is a professional Job Placement and Payroll Outsourcing Service Provider, specializing in connecting businesses with highly qualified and experienced professionals across diverse levels and roles.")
            }
            P({ style { marginTop(20.px); fontSize(18.px); property("opacity", "0.9") } }) {
                Text("Based in Indore, Ganraj Jobs is a growing HR services firm focused on delivering structured recruitment solutions that align talent with organizational requirements and support businesses in building capable teams.")
            }
        }
    }
}

@Composable
fun VisionMissionSection() = Section({
    classes(AppStyles.container); style { padding(10.px, 22.px, 40.px, 22.px) }
}) {
    Div({
        style {
            display(DisplayStyle.Grid); gridTemplateColumns("repeat(auto-fit, minmax(280px, 1fr))"); gap(
            40.px
        )
        }
    }) {
        Div({ classes(AppStyles.card); style { backgroundColor(Color("#f0f9ff")) } }) {
            H3({ style { color(Color("#0bade3")); marginBottom(16.px) } }) {
                I({
                    classes("material-icons"); style {
                    property(
                        "vertical-align",
                        "middle"
                    ); property("margin-right", 8.px)
                }
                }) { Text("visibility") }
                Text("OUR VISION")
            }
            P({ style { fontSize(18.px); lineHeight("1.6"); color(Color("#1a365d")) } }) {
                Text("To become a trusted HR partner known for connecting the right talent with the right opportunities and delivering reliable HR and payroll solutions that drive sustainable business growth.")
            }
        }
        Div({ classes(AppStyles.card); style { backgroundColor(Color("#f0f9ff")) } }) {
            H3({ style { color(Color("#0bade3")); marginBottom(16.px) } }) {
                I({
                    classes("material-icons"); style {
                    property(
                        "vertical-align",
                        "middle"
                    ); property("margin-right", 8.px)
                }
                }) { Text("rocket_launch") }
                Text("OUR MISSION")
            }
            P({ style { fontSize(18.px); lineHeight("1.6"); color(Color("#1a365d")) } }) {
                Text("To deliver transparent, efficient, and dependable Job Placement, Payroll Outsourcing, and HR solutions that empower businesses to build strong teams while helping individuals achieve meaningful career opportunities.")
            }
        }
    }
}

@Composable
fun CoreValuesSection() = Section({
    style { backgroundColor(Color.white); padding(20.px, 0.px) }
}) {
    Div({ classes(AppStyles.container) }) {
        H2({
            classes(AppStyles.sectionTitle)
            style { marginBottom(40.px) }
        }) { Text("OUR CORE VALUES") }

        Div({
            style {
                display(DisplayStyle.Grid); gridTemplateColumns("repeat(auto-fit, minmax(200px, 1fr))"); gap(
                24.px
            )
            }
        }) {
            ValueCard("🤝", "Trust", "We build relationships based on honesty and transparency.")
            ValueCard(
                "🎯",
                "Commitment",
                "We deliver every service with dedication and responsibility."
            )
            ValueCard("⚖️", "Integrity", "We act ethically and professionally in everything we do.")
            ValueCard(
                "⭐",
                "Excellence",
                "We focus on quality, accuracy, and continuous improvement."
            )
            ValueCard(
                "🌱",
                "Growth",
                "We believe in growing together with our clients and candidates."
            )
        }
    }
}

@Composable
fun ValueCard(emoji: String, title: String, desc: String) = Div({
    classes(AppStyles.card); style { property("text-align", "center"); padding(24.px) }
}) {
    Span({ style { fontSize(40.px); marginBottom(16.px); display(DisplayStyle.Block) } }) {
        Text(
            emoji
        )
    }
    H3({ style { margin(8.px, 0.px) } }) { Text(title) }
    P({ style { color(Color("#64748b")); fontSize(14.px) } }) { Text(desc) }
}

@Composable
fun WhyCard(icon: String, title: String, desc: String) = Div({
    classes(AppStyles.whyCard)
}) {
    I({
        classes("material-icons")
        style { fontSize(40.px); color(Color("#0bade3")); marginBottom(16.px) }
    }) { Text(icon) }
    H3({ style { margin(0.px); marginBottom(12.px) } }) { Text(title) }
    P({ style { color(Color("#64748b")); fontSize(15.px); lineHeight("1.5") } }) { Text(desc) }
}

@Composable
fun WhatMakesUsDifferentSection() = Section({
    style { backgroundColor(Color("#e0f2fe")); padding(20.px, 0.px, 40.px, 0.px) }
}) {
    Div({ classes(AppStyles.container) }) {
        H2({
            classes(AppStyles.sectionTitle)
            style { marginBottom(12.px) }
        }) { Text("WHAT MAKES GANRAJ DIFFERENT?") }

        P({
            classes(AppStyles.sectionSubtitle)
            style { marginBottom(40.px); color(Color("#0bade3")); fontWeight("600") }
        }) { Text("“Beyond Services. Creating Value That Matters.”") }

        Div({
            style {
                display(DisplayStyle.Grid); gridTemplateColumns("repeat(auto-fit, minmax(280px, 1fr))"); gap(
                32.px
            )
            }
        }) {
            WhyCard(
                "monetization_on",
                "1. Competitive Pricing. Superior Value.",
                "Market-competitive pricing that delivers greater value without compromising service quality."
            )
            WhyCard(
                "stars",
                "2. Quality Over Quantity",
                "We prioritize the right fit over volume, focusing on relevant candidates, suitable opportunities, and reliable service outcomes rather than simply closing assignments."
            )
            WhyCard(
                "hub",
                "3. Integrated HR Solutions",
                "Recruitment, payroll outsourcing, and HR support—comprehensive HR solutions under one roof."
            )
            WhyCard(
                "handshake",
                "4. Partnership Beyond Services",
                "Our partnership goes beyond service delivery, with continued guidance on relevant HR, recruitment, and payroll matters whenever needed."
            )
            WhyCard(
                "psychology",
                "5. Career & Interview Guidance",
                "We offer practical guidance on resume development, interview skills, role-specific case studies, professional grooming, appropriate attire, body language, and confident communication."
            )
        }

        Div({
            style {
                marginTop(60.px); backgroundColor(Color.white); padding(40.px); borderRadius(28.px)
                border(1.px, LineStyle.Solid, Color("#b9d7ea"))
                property("text-align", "center")
            }
        }) {
            H3({ style { color(Color("#1a365d")); margin(0.px) } }) { 
                Text("Professional Solutions. Better Value. Long-Term Partnerships.") 
            }
        }
    }
}

@Composable
fun AppFooter() = org.jetbrains.compose.web.dom.Footer({
    style {
        backgroundColor(Color("#0a2540")); color(Color.white); padding(
        40.px,
        0.px
    ); marginTop(40.px)
    }
}) {
    Div({
        classes(AppStyles.container); style {
        display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(
        AlignItems.Center
    )
        flexWrap(FlexWrap.Wrap); gap(32.px)
    }
    }) {
        Div {
            Div({
                style {
                    display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px); marginBottom(
                    12.px
                )
                }
            }) {
                Img(src = "logo.png", alt = "Logo") {
                    style {
                        width(32.px); height(32.px); borderRadius(8.px); property(
                        "object-fit",
                        "cover"
                    )
                    }
                }
                B({ style { fontSize(24.px); color(Color("#0bade3")) } }) { Text("ganrajjobs.com") }
            }
            P({ style { color(rgba(255, 255, 255, 0.7)); margin(0.px); maxWidth(400.px) } }) {
                Text("Building Trust. Creating Careers. Delivering top-tier placement and payroll solutions.")
            }
            P({
                style {
                    color(rgba(255, 255, 255, 0.9))
                    fontSize(14.px); marginTop(12.px); fontWeight("600")
                }
            }) { Text("Reg No.: INDO260714SE002385") }
            P({
                style {
                    color(
                        rgba(
                            255,
                            255,
                            255,
                            0.5
                        )
                    ); fontSize(14.px); marginTop(12.px)
                }
            }) { Text("© 2026 ganrajjobs.com. All rights reserved.") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(20.px) } }) {
            SocialLink(
                "https://www.linkedin.com/in/monikajahagirdar/",
                "fa-brands fa-linkedin-in",
                "#0077b5"
            )
            SocialLink(
                "https://www.instagram.com/ganrajjobs?igsh=MTdkanE1eTN3NG1qYg==",
                "fa-brands fa-instagram",
                "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)"
            )
            SocialLink("mailto:info@ganrajjobs.com", "fa-solid fa-envelope", "#0bade3")
            SocialLink(
                "https://www.facebook.com/share/19LgFQgu1P/",
                "fa-brands fa-facebook-f",
                "#0bade3"
            )
            SocialLink(
                "https://maps.app.goo.gl/svjXa9ZCwMUcvLUq6?g_st=aw",
                "fa-solid fa-location-dot",
                "#0bade3"
            )
            SocialLink("tel:+918982126663", "fa-solid fa-phone", "#0bade3")
        }
    }
}

@Composable
fun SocialSidebar() = Div({ classes(AppStyles.socialSidebar) }) {
    SidebarLink(
        "https://www.linkedin.com/in/monikajahagirdar/",
        "fa-brands fa-linkedin-in",
        "#0077b5"
    )
    SidebarLink(
        "https://www.instagram.com/ganrajjobs?igsh=MTdkanE1eTN3NG1qYg==",
        "fa-brands fa-instagram",
        "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)"
    )
    SidebarLink("https://www.facebook.com/share/19LgFQgu1P/", "fa-brands fa-facebook-f", "#1877f2")
    SidebarLink("tel:+918982126663", "fa-solid fa-phone", "#0bade3")
}

@Composable
fun SidebarLink(href: String, iconClass: String, bg: String) = A(href = href, attrs = {
    classes(AppStyles.sidebarIcon); attr("target", "_blank")
    style { background(bg) }
}) {
    I({ classes(iconClass.split(" ")) })
}

@Composable
fun WhatsAppFAB() = A(href = "https://wa.me/918982126663", attrs = {
    classes(AppStyles.whatsappFab); attr("target", "_blank")
}) {
    I({ classes("fa-brands", "fa-whatsapp") })
}

@Composable
fun SocialLink(href: String, iconClass: String, brandBg: String) = A(href = href, attrs = {
    classes(AppStyles.socialIcon); attr("target", "_blank")
    style { background(brandBg) }
}) {
    I({ classes(iconClass.split(" ")) })
}
